import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../services/api';

// Generate or get visitor ID
const getVisitorId = () => {
  let visitorId = localStorage.getItem('haullogix_visitor_id');
  if (!visitorId) {
    visitorId = 'v_' + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    localStorage.setItem('haullogix_visitor_id', visitorId);
  }
  return visitorId;
};

// Generate session ID (new per browser session)
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('haullogix_session_id');
  if (!sessionId) {
    sessionId = 's_' + Math.random().toString(36).substring(2, 15);
    sessionStorage.setItem('haullogix_session_id', sessionId);
  }
  return sessionId;
};

export const useAnalytics = () => {
  const location = useLocation();
  const lastPath = useRef('');

  useEffect(() => {
    // Don't track if same path (prevents double tracking on re-renders)
    if (location.pathname === lastPath.current) return;
    lastPath.current = location.pathname;

    // Don't track driver app pages or admin analytics
    if (location.pathname.startsWith('/driver') || location.pathname.includes('/admin/analytics')) {
      return;
    }

    const trackPageView = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user') || 'null');
        
        await api.post('/analytics/pageview', {
          page_path: location.pathname,
          page_title: document.title,
          visitor_id: getVisitorId(),
          user_id: user?.id || null,
          referrer: document.referrer || null,
          session_id: getSessionId()
        });
      } catch (error) {
        // Silently fail - analytics shouldn't break the app
        console.debug('Analytics tracking failed:', error);
      }
    };

    // Small delay to ensure page has loaded
    const timer = setTimeout(trackPageView, 100);
    return () => clearTimeout(timer);
  }, [location.pathname]);
};

export default useAnalytics;
